export const selectUserList = (state) => state.user.userList;
export const selectMessageList = (state) => state.user.errorMessages;
